module.exports = __webpack_public_path__ + "static/media/trigger-clock.a157d45c.svg";